// Keep the identity function around for default iteratees.
export default function identity(value) {
  return value;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/underscore/modules/identity.js
// module id = 229
// module chunks = 0